import type { LoginMenu } from '@features/auth'
import { routePaths } from '@config/routes'
import { menuHref, menuLabel } from '@/shared/navigation/menuTrail'
import { normalizeRoutePath } from '@/shared/navigation/menuPathResolver'

function pathsMatch(a: string, b: string): boolean {
  return normalizeRoutePath(a) === normalizeRoutePath(b)
}

export function isUserRegistrationMenu(item: LoginMenu): boolean {
  const href = menuHref(item.pageName)
  const label = menuLabel(item).trim().toLowerCase()

  return pathsMatch(href, routePaths.userDetails) || label === 'user registration'
}

/** Screens registered with requireCompany: false — enable in sidebar before company selection. */
export function isMenuAvailableWithoutCompany(item: LoginMenu): boolean {
  const href = menuHref(item.pageName)

  return (
    isUserRegistrationMenu(item) ||
    pathsMatch(href, routePaths.welcome) ||
    pathsMatch(href, routePaths.isinHistories) ||
    pathsMatch(href, routePaths.findYourShareHolder) ||
    pathsMatch(href, routePaths.userAccessLog) ||
    pathsMatch(href, routePaths.bookClosureInfoForAll) ||
    pathsMatch(href, routePaths.iepfShare)
  )
}

export function isMenuItemEnabled(item: LoginMenu, hasCompanySelected: boolean): boolean {
  if (hasCompanySelected) return true
  return isMenuAvailableWithoutCompany(item)
}

export function isPathAllowedWithoutCompany(pathname: string): boolean {
  const path = normalizeRoutePath(pathname)

  return (
    path === normalizeRoutePath(routePaths.welcome) ||
    path === normalizeRoutePath(routePaths.userDetails) ||
    path === normalizeRoutePath(routePaths.isinHistories) ||
    path === normalizeRoutePath(routePaths.findYourShareHolder) ||
    path === normalizeRoutePath(routePaths.userAccessLog) ||
    path === normalizeRoutePath(routePaths.bookClosureInfoForAll) ||
    path === normalizeRoutePath(routePaths.iepfShare)
  )
}

export const MENU_DISABLED_TITLE = 'Select a company on the home page to open this menu'
